var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2754 33C17.7254 33 17.2546 32.8042 16.8629 32.4125C16.4712 32.0208 16.2754 31.55 16.2754 31V17C16.2754 16.45 16.4712 15.9792 16.8629 15.5875C17.2546 15.1958 17.7254 15 18.2754 15H22.4754C22.6921 14.4 23.0546 13.9167 23.5629 13.55C24.0712 13.1833 24.6421 13 25.2754 13C25.9087 13 26.4796 13.1833 26.9879 13.55C27.4962 13.9167 27.8587 14.4 28.0754 15H32.2754C32.8254 15 33.2962 15.1958 33.6879 15.5875C34.0796 15.9792 34.2754 16.45 34.2754 17V31C34.2754 31.55 34.0796 32.0208 33.6879 32.4125C33.2962 32.8042 32.8254 33 32.2754 33H18.2754ZM20.2754 29H27.2754V27H20.2754V29ZM20.2754 25H30.2754V23H20.2754V25ZM20.2754 21H30.2754V19H20.2754V21ZM25.2754 16.25C25.4921 16.25 25.6712 16.1792 25.8129 16.0375C25.9546 15.8958 26.0254 15.7167 26.0254 15.5C26.0254 15.2833 25.9546 15.1042 25.8129 14.9625C25.6712 14.8208 25.4921 14.75 25.2754 14.75C25.0587 14.75 24.8796 14.8208 24.7379 14.9625C24.5962 15.1042 24.5254 15.2833 24.5254 15.5C24.5254 15.7167 24.5962 15.8958 24.7379 16.0375C24.8796 16.1792 25.0587 16.25 25.2754 16.25Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24669",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24669",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.56882aaab07d7bc1fd43d2f77268f6f5.svg";
export { ForwardRef as ReactComponent };